import React from 'react'
import { withRouter } from 'react-router-dom'
import { Result, Button } from 'antd'

class NotExists extends React.Component {
    onClick = (e) => {
        this.props.history.push('/search/feature')
    }
    
    render() {
        return (
            <Result
                status="404"
                title="Feature Not Exists."
                subTitle="Please check if the feature id exists."
                extra={<Button type="primary" onClick={this.onClick}>Search Feature</Button>}
            />
        )
    }
}

export default withRouter(NotExists)